import { useEffect } from 'react';
import { NavLink, Outlet, useLocation } from 'react-router-dom';
import { useApp } from '../estado';
import { Icone, type NomeIcone } from './ui';

interface ItemNav {
  para: string;
  rotulo: string;
  icone: NomeIcone;
  titulo: string;
}

interface GrupoNav {
  grupo: string;
  itens: ItemNav[];
}

const NAVEGACAO: GrupoNav[] = [
  {
    grupo: 'Operação',
    itens: [
      { para: '/', rotulo: 'Visão Geral', icone: 'painel', titulo: 'Visão Geral' },
      { para: '/disparos', rotulo: 'Disparos', icone: 'disparos', titulo: 'Disparos' },
      { para: '/eventos', rotulo: 'Eventos e Titulares', icone: 'eventos', titulo: 'Eventos e Titulares' },
    ],
  },
  {
    grupo: 'Réguas',
    itens: [
      { para: '/receitas', rotulo: 'Receitas', icone: 'receitas', titulo: 'Receitas' },
      { para: '/templates', rotulo: 'Templates', icone: 'templates', titulo: 'Templates' },
    ],
  },
  {
    grupo: 'Provedor',
    itens: [
      { para: '/configuracoes', rotulo: 'Configurações', icone: 'configuracoes', titulo: 'Configurações' },
      { para: '/auditoria', rotulo: 'Auditoria', icone: 'auditoria', titulo: 'Auditoria' },
    ],
  },
];

const TODOS = NAVEGACAO.flatMap((grupo) => grupo.itens);

export function Layout() {
  const { usuario, provedor, marca, sair, notificar } = useApp();
  const local = useLocation();
  const branding = provedor?.branding ?? marca?.branding;

  const atual =
    TODOS.find((item) => item.para === local.pathname) ??
    TODOS.find((item) => item.para !== '/' && local.pathname.startsWith(item.para));

  // O título da aba carrega a página e o Provedor; a tela não precisa repetir
  // o nome da página num cabeçalho próprio.
  useEffect(() => {
    const provedorNome = provedor?.nome ?? 'Disparos';
    document.title = atual ? `${atual.titulo} · ${provedorNome}` : provedorNome;
  }, [atual, provedor?.nome]);

  const encerrar = async () => {
    try {
      await sair();
    } catch {
      notificar('erro', 'Não foi possível encerrar a sessão no servidor.');
    }
  };

  return (
    <div className="app">
      <a className="pular-link" href="#conteudo">
        Pular para o conteúdo
      </a>

      <aside className="barra-lateral">
        <a
          className="marca"
          href="/"
          aria-label={`${branding?.nomeExibicao ?? 'Disparos'} — Visão Geral`}
        >
          <img
            className="marca__logo"
            src={branding?.logoUrl ?? '/logo-banner.svg'}
            alt=""
            width={188}
            height={40}
          />
        </a>

        <nav aria-label="Navegação principal">
          {NAVEGACAO.map((grupo) => (
            <div key={grupo.grupo}>
              <p className="nav__grupo">{grupo.grupo}</p>
              <ul className="nav">
                {grupo.itens.map((item) => (
                  <li key={item.para}>
                    {/* NavLink marca a rota activa com aria-current="page". */}
                    <NavLink to={item.para} end={item.para === '/'} className="nav__link">
                      <Icone nome={item.icone} className="nav__icone" />
                      {item.rotulo}
                    </NavLink>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </nav>

        <div className="barra-lateral__rodape">
          <div className="usuario">
            <span className="usuario__nome">{usuario?.nome}</span>
            <span className="usuario__papel">
              {usuario?.papel === 'admin' ? 'Administrador' : 'Atendente'} · {usuario?.email}
            </span>
          </div>
          <button type="button" className="botao botao--secundario botao--pequeno" onClick={encerrar}>
            <Icone nome="sair" className="nav__icone" />
            Sair
          </button>
        </div>
      </aside>

      <div className="conteudo" id="conteudo">
        <div className="pagina">
          <Outlet />
        </div>
      </div>
    </div>
  );
}
